<template lang="pug">
#visualizar-processamento-contrato
    BaseHeader(
        :titulo='$t("mensagens.subEmpresaGestao.visualizarRastreabilidadeSubEmpresaContrato.titulo")',
        :exibeBotao='!foiConcluido',
        :btnTexto='$t("mensagens.subEmpresaGestao.visualizarRastreabilidadeSubEmpresaContrato.concluirContrato")',
        icon='el-icon-check',
        :voltarPara='true',
        :desabilitaBotao='!botaoConcluirHabilitado',
        @btnHeaderClicado='concluirProcessamento'
    )

    .view-container.alinhar-conteudo.margen-bottom-pages
        div(v-if='mensagemValidacaoConcluir.length && !foiConcluido')
            el-alert(
                :title='$t("mensagens.subEmpresaGestao.visualizarRastreabilidadeSubEmpresaContrato.avisos")',
                type='warning',
                show-icon,
                :closable='false'
            )
                ul
                    li(v-for='mensagem in mensagemValidacaoConcluir') {{ mensagem }}

        .blocoDadosVisualizarContratoOriginacao
            section
                SubEmpresaBlocoDadosVisualizarContratoOriginacaoAR(
                    :dados='dados'
                )

        section
            Resumo(:resumo='resumo')

        ModalAnaliseElegibilidadeResumoAr(
            :show='ativarModalAnaliseElegibilidade',
            :dados='dadosAnaliseElegibilidade',
            @handleCloseModalAnaliseElegibidade='ativarModalAnaliseElegibilidade = false'
        )

        section
            TabelaCarsInseridosNoContratoAR(
                ref='tabelaTerritorioAR',
                :isSucursal='true',
                :btnRecarregar='true',
                :territoriosNaoEnviados='dataTerritoriosNaoEnviados',
                :removendo='removendoTerritoriosCertificados',
                :volumeDisponivelContrato='volumeDisponivelContrato',
                :carregando='loadingTabelaCarsInseridosNoContrato',
                :paginacao='paginacao',
                :statusSubEmpresaCodigo='statusSubEmpresaCodigo',
                :idSucursal='$route.params.idSucursal || $route.query.idSucursal || 0',
                @removerTerritorioLote='removerTerritorioLote',
                @territorioRemovido='atualizarDados',
                @mudarPagina='mudarPagina',
                @realizarElegibilidade='realizarElegibilidade',
                @visualizarAnaliseElegibilidadeAr='visualizarAnaliseElegibilidadeAr',
                @atualizarTabela='atualizarListagemTerritorios'
            )
        footer.area-footer
            .botao-certificacao__remover
                el-button(
                    v-if='removendoTerritoriosCertificados',
                    @click.native='removendoTerritoriosCertificados = false'
                ) {{ $t('mensagens.subEmpresaGestao.tabelaCarsInseridosNoContrato.cancelar') }}

                el-button(
                    v-if='!removendoTerritoriosCertificados',
                    type='danger',
                    icon='el-icon-delete',
                    @click.native='removendoTerritoriosCertificados = true',
                    :disabled='this.territoriosSelecionados.length === 0'
                ) {{ $t('mensagens.subEmpresaGestao.tabelaCarsInseridosNoContrato.remover') }}

                el-button(
                    v-else,
                    type='danger',
                    icon='el-icon-delete',
                    @click.native='removerTerritorio'
                ) {{ $t('mensagens.subEmpresaGestao.tabelaCarsInseridosNoContrato.confirmar') }}

            .botao-territorio__enviar-para-analise

    ModalDetalheAnalise(ref='refModalDetalheAnalise')
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import SubEmpresaBlocoDadosVisualizarContratoOriginacaoAR from '@/components/contratosOriginacao/SubEmpresaBlocoDadosVisualizarContratoOriginacaoAR.vue';
import Resumo from '@/components/contratosOriginacao/SubEmpresaBlocoResumoContratoOriginacao.vue';
import TabelaCarsInseridosNoContratoAR from '@/components/contratosOriginacao/TabelaCarsInseridosNoContratoAR.vue';
import SucursaleService from '@/services/SucursaleService';
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
import ModalDetalheAnalise from '@/components/contratosOriginacao/ModalDetalheAnalise.vue';
import ModalAnaliseElegibilidadeResumoAr from '@/components/contratosOriginacao/ModalAnaliseElegibilidadeResumoAr.vue';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import { mascaraRenspa } from '@/utils/masks/renspa.js';
import { mapGetters } from 'vuex';
import RaioPermitidoPorEstadoRastreabilidadeService from '@/services/RaioPermitidoPorEstadoRastreabilidadeService';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'VizualizarContratoSucursales',
    components: {
        ModalDetalheAnalise,
        BaseHeader,
        SubEmpresaBlocoDadosVisualizarContratoOriginacaoAR,
        Resumo,
        TabelaCarsInseridosNoContratoAR,
        ModalAnaliseElegibilidadeResumoAr
    },

    data() {
        return {
            numeroContrato: this.$route.params.numeroContrato,
            idSucursal: this.$route.params.idSucursal,
            dados: {},
            resumo: {},
            botaoConcluirHabilitado: false,
            foiConcluido: false,
            ambientes: AmbientesEmpresas,
            mensagemValidacaoConcluir: [],
            habilitarBotaoConcluir: false,
            dataTerritoriosNaoEnviados: [],
            removendoTerritoriosCertificados: false,
            territoriosSelecionados: [],
            volumeDisponivelContrato: 0,
            loadingTabelaCarsInseridosNoContrato: false,
            raiosPermitidosPorEstado: [],
            paginacao: {
                pagina: 0,
                total: null,
                itensPorPagina: 10
            },
            ativarModalAnaliseElegibilidade: false,
            dadosAnaliseElegibilidade: {
                elegibilidade: '',
                valor: '',
                safraNome: '',
                dadosDiagnostico: {
                    territorioNome: '',
                    diagnosticoRepresentante: [],
                    diagnosticoCar: null,
                    resultadoDiagnosticoRastreabilidade: null,
                    nivelAlertaRastreabilidade: null
                },
                dadosCalculoRaio: {
                    distanciaRaioMunicipioECar: null,
                    possuiIntersecao: null
                },
                dadosBuscaSaldo: {
                    id: null,
                    codigoCar: '',
                    capacidadeProdutiva: null,
                    saldoCARcapacidadeProdutiva: null,
                    calculoSaca: {
                        saldoCARcapacidadeProdutivaSaca: null,
                        saldoCarComprometido: null
                    },
                    cultura: {
                        id: null,
                        nome: '',
                        codigo: ''
                    },
                    anoSafra: {
                        id: null,
                        ano: null,
                        tipoSafra: '',
                        descricao: ''
                    },
                    criadoEm: null,
                    saldoCarComprometido: null
                }
            },
            loadingResumo: {
                loadingRaio: false,
                loadingSaldo: false,
                analiseElegibilidade: false
            },
            statusSubEmpresaCodigo: '',
            dadosDetalheAnaliseElegibilidadePY: {},
            dadosCalculoRaioPY: {}
        };
    },

    mounted() {
        this.buscarRaiosPermitidosPorEstado();
        this.buscarInformacoesContrato();
        this.buscarTerritorios(0);
    },

    computed: {
        ...mapGetters(['usuarioLogado'])
    },

    beforeDestroy() {
        disconnect();
    },

    methods: {
        async buscarInformacoesContrato() {
            try {
                const { data } = await SucursaleService.vizualizarContrato({
                    numeroContrato: this.numeroContrato,
                    idSucursal: this.$route.params.idSucursal
                });

                const {
                    numeroContrato,
                    materialNome,
                    safraNome,
                    volumeContratado,
                    dataCadastro,
                    localidadeNivelUmNome,
                    localidadeNivelUmSigla,
                    municipioNome,
                    nomeCliente,
                    volumeInseridoSemRestricao,
                    volumeComRestricoes,
                    volumeInseridoTotal,
                    saldoRestante,
                    territoriosInseridos,
                    territoriosConformes,
                    territorioComAlertas,
                    territoriosInConformes,
                    statusSubEmpresaCodigo,
                    codigoExterno,
                    vendedor,
                    cuitVendedor,
                    anoColheitaAfip,
                    dataContrato,
                    plantaEntregaBungeNome,
                    dataPrevistaEntrega,
                    estruturaComercial,
                    condicaoCliente,
                    condicaoFrete,
                    localidadeNivelDoisSigla,
                    localidadeNivelDoisNome,
                    localidadeNivelDoisId,
                    localidadeNivelTresSigla,
                    localidadeNivelQuatroNome,
                    localidadeNivelTresId
                } = data;

                this.dados = {
                    numeroContrato,
                    materialNome,
                    safraNome,
                    volumeContratado,
                    dataCadastro,
                    localidadeNivelUmNome,
                    localidadeNivelUmSigla,
                    nomeCliente,
                    municipioNome,
                    codigoExterno,
                    saldoRestante,
                    volumeInseridoTotal,
                    vendedor,
                    cuitVendedor,
                    anoColheitaAfip,
                    dataContrato,
                    dataPrevistaEntrega,
                    estruturaComercial,
                    plantaEntregaBungeNome,
                    condicaoCliente,
                    condicaoFrete,
                    localidadeNivelDoisSigla,
                    localidadeNivelDoisNome,
                    localidadeNivelDoisId,
                    localidadeNivelTresSigla,
                    localidadeNivelQuatroNome,
                    localidadeNivelTresId
                };

                this.resumo = {
                    volumeContratado,
                    volumeInseridoSemRestricao,
                    volumeComRestricoes,
                    saldoRestante,
                    territoriosInseridos,
                    territoriosConformes,
                    territoriosInConformes,
                    territorioComAlertas
                };

                const statusConcluidos = ['CONCLUIDO', 'AJUSTADO_PELA_REVENDA'];
                this.foiConcluido = statusConcluidos.includes(statusSubEmpresaCodigo);
                this.statusSubEmpresaCodigo = statusSubEmpresaCodigo;

                this.verificaConcluir();
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.buscarInfoContrato'
                    )
                });
            }
        },

        async concluirProcessamento() {
            this.concluirProcessamentoAR();
        },

        async concluirProcessamentoAR() {
            try {
                const resultado =
                    await SucursaleService.concluirProcessamentoContrato({
                        contrato: this.numeroContrato,
                        idSucursal: this.$route.params.idSucursal
                    });

                this.$router.push({ name: 'RastreabilidadeSucursales' });

                this.$notify.success({
                    message: resultado.data
                });
            } catch (error) {
                this.$notify.error({
                    message: error.response.data.message
                });
            }
        },

        async conectarCanalWebsocket() {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.tabelaCarsInseridosNoContrato.territorioInelegivel'
                    )
                });
                return;
            }

            try {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/contrato-originacao/subempresa/analise-concluida`,
                    response => {
                        this.buscarInformacoesContrato();
                        this.atualizarListagemTerritorios();
                        disconnect();
                    }
                );
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.tabelaCarsInseridosNoContrato.naoPossivelRealizarAnalise'
                    )
                });
                disconnect();
            }
        },

        async verificaConcluir() {
            this.mensagemValidacaoConcluir = [];
            try {
                const { data } =
                    await SucursaleService.verificaSePodeConcluirOContrato(
                        this.numeroContrato,
                        this.idSucursal
                    );

                this.botaoConcluirHabilitado = data.podeConcluir;

                this.mensagemValidacaoConcluir = data.avisos;

                if (this.foiConcluido) {
                    this.botaoConcluirHabilitado = false;
                } else {
                    this.conectarCanalWebsocket();
                }
            } catch (error) {
                this.mensagemValidacaoConcluir = [];

                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.contratoConcluido'
                    )
                });
            }
        },
        atualizarDados() {
            this.paginacao = {
                pagina: 0,
                total: null,
                itensPorPagina: 10
            };
            setTimeout(() => {
                this.buscarTerritorios(0);
            }, 1000);
        },
        atualizarListagemTerritorios() {
            this.buscarTerritorios(0);
        },
        mudarPagina(novaPagina) {
            this.buscarTerritorios(novaPagina);
        },
        realizarElegibilidade(territorioAnalise) {
            this.territoriosSelecionados = territorioAnalise;
        },
        async visualizarAnaliseElegibilidadeAr(row) {
            try {
                const numeroContrato = this.$route.params.numeroContrato;
                const idTerritorio = row.idTerritorio;
                const idSucursal = this.$route.params.idSucursal || this.$route.query.idSucursal || 0;

                // Usar endpoint consolidado em vez dos endpoints antigos
                const { data } = await ContratoOriginacaoServiceSubEmpresa.buscarResumoAnaliseElegibilidadePreInsercaoTerritorioAr({
                    idRepresentante: 0,
                    idTerritorio: idTerritorio,
                    numeroContrato: numeroContrato,
                    isSucursal: true,
                    idDadosContratoOriginacao: row.id,
                    idSucursal: idSucursal
                });

                // Mapear dados para estrutura unificada
                this.dadosAnaliseElegibilidade.dadosDiagnostico = data.diagnosticoSocioambiental;
                this.dadosAnaliseElegibilidade.dadosCalculoRaio = data.raioTerritorio;
                this.dadosAnaliseElegibilidade.elegibilidade = data.resultadoResumoAnaliseElegibilidadePreInsercaoTerritorioSubempresa;
                this.dadosAnaliseElegibilidade.saldoTerritorial = data.diagnosticoSaldoTerritorial;
                this.dadosAnaliseElegibilidade.territorioOutput = data.territorioOutput;
                this.dadosAnaliseElegibilidade.certificacao = data.certificacao;

                this.ativarModalAnaliseElegibilidade = true;
            } catch (e) {
                if (
                    e.response?.data?.message ===
                    'rendimento.provinciaEDepartamentoNaoEncontrado'
                ) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.erroRendimento'
                        )
                    });
                    return;
                }

                this.$notify.error({
                    message: e.response?.data?.message
                });
            }
        },
        async buscarTerritorios(pagina) {
            try {
                this.loadingTabelaCarsInseridosNoContrato = true;
                this.paginacao.pagina = pagina;

                const { data } = await SucursaleService.territoriosNaoEnviados({
                    contrato: this.$route.params.numeroContrato,
                    idSucursal: this.$route.params.idSucursal,
                    pagina: this.paginacao.pagina,
                    tamanho: this.paginacao.itensPorPagina
                });

                const dataRenspaFormatado = data.itens.map(item => ({
                    ...item,
                    cuit: item.territorioRepresentantes ? this.alterarMascara(
                        item.territorioRepresentantes[0].cpfCnpj
                    ) : '',
                    renspaTerritorio: mascaraRenspa(item.renspaTerritorio)
                }));
                this.dataTerritoriosNaoEnviados = dataRenspaFormatado;

                this.atualizarPaginacao(data.paginacao);
            } catch (erro) {
                this.$toast.error('Não foi possível carregar os territórios');
            } finally {
                this.loadingTabelaCarsInseridosNoContrato = false;
            }
        },

        formatarTerritorios(territorios) {
            return territorios.map(territorio => ({
                ...territorio,
                cuit: this.obterCuitFormatado(territorio),
                renspaTerritorio: mascaraRenspa(territorio.renspaTerritorio)
            }));
        },

        obterCuitFormatado(territorio) {
            const primeiroRepresentante = territorio?.territorioRepresentantes?.[0];
            return primeiroRepresentante?.cpfCnpj
                ? this.alterarMascara(primeiroRepresentante.cpfCnpj)
                : '';
        },

        atualizarPaginacao(novaPaginacao) {
            this.paginacao = {
                ...novaPaginacao,
                pagina: novaPaginacao.pagina + 1
            };
        },
        
        removerTerritorioLote(territorioRemover) {
            this.territoriosSelecionados = territorioRemover;
        },
        alterarMascara(cpf) {
            const somenteNumeros = cpf.replace(/\D/g, '');
            const novaMascara = somenteNumeros.replace(
                /^(\d{2})(\d{8})(\d)$/,
                '$1-$2-$3'
            );

            return novaMascara;
        },
        async removerTerritorio() {
            if (this.territoriosSelecionados.length === 0) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.naoHaTerritoriosRemocao'
                    )
                );
            } else {
                await this.$messageBox.confirm(
                    this.territoriosSelecionados.length === 1
                        ? this.$t(
                              'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.removerTerritorio'
                          )
                        : this.$t(
                              'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.removerTerritorios'
                          ),
                    this.$t(
                        'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.avisos.aviso'
                    ),
                    {
                        confirmButtonText: this.$t(
                            'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.avisos.confirmar'
                        ),
                        cancelButtonText: this.$t(
                            'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.avisos.cancelar'
                        ),
                        type: 'warning'
                    }
                );
                try {
                    await this.$nextTick(() => {
                        this.$refs.tabelaTerritorioAR.removerTerritoriosEmLote(
                            this.territoriosSelecionados
                        );
                    });

                    this.removendoTerritoriosCertificados = false;
                    this.atualizarDados();
                } catch (error) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.tabelaCarsInseridosNoContrato.erroRequisicao'
                        )
                    });
                }
            }
        },
        async buscarRaiosPermitidosPorEstado() {
            const { data } =
                await RaioPermitidoPorEstadoRastreabilidadeService.findAll();
            this.raiosPermitidosPorEstado = data;
        }
    }
};
</script>

<style lang="scss">
#visualizar-processamento-contrato {
    .alinhar-conteudo {
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-top: 16px;
    }

    .el-alert__title {
        color: #737373;
    }

    .el-alert__description {
        color: #737373;
    }

    .area-footer {
        display: flex;
        justify-content: space-between;
    }
}
</style>
